import React from "react";
import { Route } from "react-router-dom";

/**
 * Reusable Route component that passes SignupClick handler to the component
 */
const RouteWithSignup = ({ component: Component, signupHandler, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Component {...props} SignupClick={signupHandler} />
      )}
    />
  );
};

export default RouteWithSignup;
